import { render, staticRenderFns } from "./ReceiptsList.vue?vue&type=template&id=22178b7c&scoped=true&"
import script from "./ReceiptsList.vue?vue&type=script&lang=js&"
export * from "./ReceiptsList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsList.vue?vue&type=style&index=0&id=22178b7c&lang=scss&scoped=true&"
import style1 from "./ReceiptsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22178b7c",
  null
  
)

export default component.exports